import { ResponsivePictureLayout } from '@news-mono/component-library'
import { Features } from '@news-mono/web-common'
import { layout } from '../../../App.routing'

export interface StateElection2021Options {
    feature: Features
    showHeading: boolean
}

export const stateElection2021Segment = (options: StateElection2021Options) => {
    return [
        layout.component({
            type: 'sierra',
            feature: options.feature,
            props: {
                verticalSpacing: 'gridGap',
                fixedRatios: ['16:9'],
                heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
                

                cardOrientation: {
                    type: 'Landscape-Portrait',
                    maxBreakpoint: 'md',
                },
                cardLayout: [
                    { type: 'hero', disableImageLazyLoad: false },
                    'teaser-xsVisible-mdHidden-Image',
                ],
                sectionHeader: options.showHeading
                    ? {
                          heading: 'State Election 2021',
                          headingUrl: '/politics/state-election-2021',
                          section: 'politics',
                      }
                    : undefined,

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'state-election-2021',
                    offset: 0,
                    pageSize: 2,
                },
            },
        }),
        layout.component({
            type: 'lima',
            feature: options.feature,
            props: {
                verticalSpacing: 'xl',
                fixedRatios: ['16:9'],
                intermediateColumns: 2,
                finalColumns: 4,
                teaserMode: 'hidden',
                hideByline: false,
                hasBackground: true,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['xsImage-mdNoImage-withBG', 'xsImage-mdNoImage-withBG'],
                    ['xsImage-mdNoImage-withBG', 'xsImage-mdNoImage-withBG'],
                    ['teaserWithBackground'],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'state-election-2021',
                    offset: 2,
                    pageSize: 9,
                },
            },
        }),
    ]
}
